import { IconWrapper } from '../runtime';
export default IconWrapper('border', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 7.99976V12.7498C1.75 13.5782 2.42157 14.2498 3.25 14.2498H8M1.75 7.99976V3.24976C1.75 2.42133 2.42157 1.74976 3.25 1.74976H8M1.75 7.99976H14.25M14.25 7.99976V3.24976C14.25 2.42133 13.5784 1.74976 12.75 1.74976H8M14.25 7.99976V12.7498C14.25 13.5782 13.5784 14.2498 12.75 14.2498H8M8 14.2498V1.74976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});